import { useRoot } from "../../contexts/Root";
import { RefObject, forwardRef } from "react";

import styles from "./styles.module.css";
import clsx from "clsx";

interface Props {
  show?: boolean;
  children: React.ReactNode;
  offset?: number;
  expand?: boolean;
  centered?: boolean;
}

export const SeekDisplay = forwardRef(
  (
    {
      show = true,
      children,
      offset = 0,
      expand = false,
      centered = false,
    }: Props,
    ref
  ) => {
    const {
      theme: { foreground, primaryBackground },
    } = useRoot();

    const style = {
      opacity: show ? 1 : 0,
      transform: `translateX(${offset}px)`,
    };

    const innerStyle = {
      color: foreground,
      background: primaryBackground,
      transform: `scale(${(centered && 1.5) || (expand && 1.15) || 1})`,
    };

    const containerClass = clsx(
      styles.container,
      centered && styles.centeredContainer
    );

    return (
      <div
        style={style}
        className={containerClass}
        ref={ref as RefObject<HTMLDivElement>}
      >
        <div style={innerStyle} className={styles.innerContainer}>
          {children}
        </div>
      </div>
    );
  }
);
